import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './DentalPlans.scss';
import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const DentalPlans = () => {

    const dentalPlans = [
        {
            'icon': iconOne,
            'title': 'Smile Card (Family Plan)',
            'price': '₹499',
            'period': '/year',
            'members': '4 Members',
            'description': 'Perfect for families! Get comprehensive dental care for your entire family at an affordable price.',
            'features': [
                'Free dental check-up for all 4 members',
                '15% OFF on all treatments',
                'Priority appointment booking',
                'Annual dental health reports',
                'Emergency dental care included'
            ],
            'highlight': 'Most Popular',
            'color': 'primary'
        },
        {
            'icon': iconTwo,
            'title': 'Student Dental Health Card',
            'price': '₹99',
            'period': '/student',
            'members': 'Student + Parents',
            'description': 'Special plan designed for students with additional benefits for parents.',
            'features': [
                'Free dental check-up for student',
                'Free brushing demonstration',
                '15% discount for parents',
                'Educational dental materials',
                'Regular follow-up sessions'
            ],
            'highlight': 'Best Value',
            'color': 'secondary'
        },
        {
            'icon': iconThree,
            'title': 'Free Dental Check-Up',
            'price': 'FREE',
            'period': '',
            'members': 'Everyone',
            'description': 'Comprehensive dental examination and consultation at absolutely no cost.',
            'features': [
                'Complete oral examination',
                'X-ray consultation',
                'Treatment planning',
                'Oral hygiene guidance',
                'Follow-up recommendations'
            ],
            'highlight': 'Limited Time',
            'color': 'success'
        },
        {
            'icon': iconFour,
            'title': '15% OFF All Treatments',
            'price': '15%',
            'period': 'OFF',
            'members': 'All Patients',
            'description': 'Get 15% discount on all dental treatments and procedures.',
            'features': [
                'Root canal treatments',
                'Dental implants',
                'Cosmetic procedures',
                'Orthodontic treatments',
                'Preventive care'
            ],
            'highlight': 'Special Offer',
            'color': 'warning'
        }
    ];

    return (
        <section className='dental-plans-section pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-10 mx-auto text-center">
                        <SectionTitle 
                            title="Choose Your Perfect Dental Plan" 
                            subTitle="Comprehensive Plans"
                            description="Select the dental plan that best suits your needs. All plans include professional care from our MDS specialist Dr. Vinamrata."
                        />
                    </div>
                </div>

                <div className="row">
                    {
                        dentalPlans.map((plan, index) => (
                            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                                <div className={`plan-card plan-card-${plan.color}`}>
                                    {plan.highlight && <div className="highlight-badge">{plan.highlight}</div>}
                                    
                                    <div className="plan-icon">
                                        <img src={plan.icon} alt={plan.title} />
                                    </div>
                                    
                                    <div className="plan-content">
                                        <h3>{plan.title}</h3>
                                        
                                        <div className="price-section">
                                            <div className="price">
                                                <span className="amount">{plan.price}</span>
                                                <span className="period">{plan.period}</span>
                                            </div>
                                            <div className="members">{plan.members}</div>
                                        </div>
                                        
                                        <p className="description">{plan.description}</p>
                                        
                                        <div className="features-list">
                                            {plan.features.map((feature, featureIndex) => (
                                                <div key={featureIndex} className="feature-item">
                                                    <span className="check-icon">✓</span>
                                                    <span>{feature}</span>
                                                </div>
                                            ))}
                                        </div>
                                        
                                        <div className="plan-action">
                                            <a href="tel:6395947006" className="call-now-btn">
                                                <span className="call-icon">📞</span>
                                                Call Now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="contact-info">
                            <h4>Need Help Choosing?</h4>
                            <p>Call us at <a href="tel:6395947006" className="phone-link">6395947006</a> for personalized assistance</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DentalPlans;
